/* ============================================================
   LINGUA — italiano di default, inglese quando la pagina è
   servita da Shopify nella versione inglese.

   Come arriva la lingua fin qui: questo file è caricato su
   Shopify come asset statico del tema e gli asset statici NON
   passano dal motore Liquid (stesso identico motivo per cui
   esistono window.CDF_IMAGES — vedi il commento accanto a
   ORDINE_BARCHE). Un tag Liquid scritto qui resterebbe testo
   letterale. Quindi è il blocco Custom Liquid (l'unica parte
   che Shopify processa davvero) a risolvere
   {{ request.locale.iso_code }} e a lasciarlo in
   window.CDF_LANG prima di caricare questo script — vedi lo
   <script> inline in configuratore-barche.html.

   I due controlli successivi sono reti di sicurezza: <html lang>
   è impostato dal tema Shopify anche se qualcuno dimenticasse di
   aggiornare il blocco Custom Liquid, e il prefisso /en/ nell'URL
   è come Shopify distingue la lingua non primaria. In locale
   (Liquid non eseguito) nessuno dei tre scatta e si resta in
   italiano, così il file .html si apre e si testa come sempre.
   ============================================================ */
function rilevaLingua(){
  // Forzatura manuale per i test: ?lang=en in fondo all'URL. Funziona sia in
  // locale (dove Liquid non gira e non c'è altro modo di vedere l'inglese)
  // sia su Shopify, senza dover cambiare la lingua del negozio.
  if(typeof location !== "undefined"){
    const daUrl = new URLSearchParams(location.search).get("lang");
    if(daUrl) return /^en/i.test(daUrl) ? "en" : "it";
  }
  const daLiquid = typeof window !== "undefined" ? window.CDF_LANG : null;
  if(typeof daLiquid === "string" && /^en/i.test(daLiquid.trim())) return "en";
  if(typeof document !== "undefined" && /^en/i.test(document.documentElement.lang || "")) return "en";
  if(typeof location !== "undefined" && /^\/en(\/|$)/i.test(location.pathname)) return "en";
  return "it";
}
const LANG = rilevaLingua();

/* ============================================================
   TRADUZIONI — testo dell'interfaccia.

   Le etichette dei DATI (nomi opzioni, descrizioni, targhette
   barca) NON stanno qui: vivono accanto al dato stesso come
   campo `_en` affiancato (es. label / label_en), così aggiungere
   una barca o un accessorio non significa doverlo ricordare in
   due punti lontani del file. Le legge l'helper L() più sotto.

   Le voci parametriche sono funzioni: t("chiave", arg1, arg2).
   Una chiave mancante in `en` ricade sull'italiano invece di
   sparire, così una traduzione incompleta si degrada in modo
   visibile ma non rotto.
   ============================================================ */
const I18N = {
  it: {
    titolo: "Configura la tua deriva",
    fase: "Fase",
    fasiComplete: ["Scegli la barca", "Personalizza", "Richiedi preventivo"],
    fasiInfo: ["Scegli la barca", "Richiedi informazioni"],

    // Step 0 — griglia barche
    aPartireDa: prezzo => `A partire da ${prezzo}`,
    specLunghezza: "Lungh.",
    specLarghezza: "Largh.",
    specSupVelica: "Sup. velica",
    specPeso: "Peso",

    // Step 1 — opzioni
    cambiaBarca: "Cambia barca",
    totaleConfigurazione: "Totale configurazione",
    kickerFinitura: "Finitura",
    titoloColoreScafo: "Colore scafo",
    inclusoDiSerie: "Incluso di serie",
    circuitiEManovre: "Circuiti e manovre",
    indietro: "← Indietro",
    vaiAlRiepilogo: "Vai al riepilogo →",

    // Step 2 — riepilogo
    prezzoBase: "Prezzo base",
    nessuno: "Nessuno",
    datiPreventivo: "I tuoi dati per il preventivo e spedizione",
    kickerContatto: "Contatto",
    labelNome: "Nome e cognome",
    phNome: "Mario Rossi",
    labelEmail: "Email",
    phEmail: "mario@esempio.it",
    labelTelefono: "Telefono (opzionale)",
    phTelefono: "+39 ...",
    kickerIndirizzo: "Indirizzo di spedizione",
    labelIndirizzo: "Indirizzo (via e numero civico)",
    phIndirizzo: "Via Roma 12",
    labelIndirizzo2: "Indirizzo aggiuntivo (opzionale)",
    phIndirizzo2: "Interno, scala, punto di riferimento...",
    labelCitta: "Città",
    phCitta: "Ancona",
    labelCap: "CAP / Codice postale",
    phCap: "60100",
    labelProvincia: "Provincia / Stato / Regione",
    phProvincia: "AN",
    labelPaese: "Paese",
    kickerNote: "Note",
    labelNote: "Note aggiuntive",
    phNote: "Tempistiche desiderate, domande, ecc.",
    consenso: "Accetto il trattamento dei dati secondo l'informativa privacy del cantiere.",
    modificaConfigurazione: "← Modifica configurazione",
    inviaPreventivo: "Invia richiesta di preventivo",

    // Step 2 (variante) — richiesta informazioni
    richiediInfoSu: nome => `Richiedi informazioni su ${nome}`,
    kickerMessaggio: "Messaggio",
    labelMessaggio: "Cosa vuoi sapere?",
    phMessaggio: "Disponibilità, tempistiche, personalizzazioni possibili, ecc.",
    tornaCambiaBarca: "← Cambia barca",
    inviaInfo: "Invia richiesta di informazioni",

    // Validazione e invio
    errNomeEmail: "Inserisci nome ed email per continuare.",
    errIndirizzo: "Inserisci l'indirizzo di spedizione completo (indirizzo, città, CAP, provincia/stato).",
    errConsenso: "Devi accettare il trattamento dei dati per inviare la richiesta.",
    errInvio: "Invio non riuscito. Riprova o contatta direttamente il cantiere.",

    // Conferma
    stampRicevuta: "Richiesta ricevuta",
    grazie: nome => `Grazie, ${nome}!`,
    confermaInfo: (barca, email) => `La tua richiesta di informazioni per il modello <strong>${barca}</strong> è stata registrata. Il cantiere ti contatterà all'indirizzo ${email} con tutte le informazioni richieste.`,
    confermaPreventivo: (barca, citta, paese, email) => `La tua richiesta di preventivo per il modello <strong>${barca}</strong> è stata registrata, comprensiva di spedizione a ${citta} (${paese}). Il cantiere ti contatterà all'indirizzo ${email} con il preventivo dettagliato.`
  },

  en: {
    titolo: "Configure your dinghy",
    fase: "Step",
    fasiComplete: ["Choose your boat", "Customise", "Request a quote"],
    fasiInfo: ["Choose your boat", "Request information"],

    aPartireDa: prezzo => `From ${prezzo}`,
    specLunghezza: "Length",
    specLarghezza: "Beam",
    specSupVelica: "Sail area",
    specPeso: "Weight",

    cambiaBarca: "Change boat",
    totaleConfigurazione: "Configuration total",
    kickerFinitura: "Finish",
    titoloColoreScafo: "Hull colour",
    inclusoDiSerie: "Standard equipment",
    circuitiEManovre: "Control lines and rigging",
    indietro: "← Back",
    vaiAlRiepilogo: "Go to summary →",

    prezzoBase: "Base price",
    nessuno: "None",
    datiPreventivo: "Your details for the quote and delivery",
    kickerContatto: "Contact",
    labelNome: "Full name",
    phNome: "John Smith",
    labelEmail: "Email",
    phEmail: "john@example.com",
    labelTelefono: "Phone (optional)",
    phTelefono: "+ country code",
    kickerIndirizzo: "Delivery address",
    labelIndirizzo: "Address (street and number)",
    phIndirizzo: "12 High Street",
    labelIndirizzo2: "Address line 2 (optional)",
    phIndirizzo2: "Flat, floor, landmark...",
    labelCitta: "City",
    phCitta: "London",
    labelCap: "Postal code / ZIP",
    phCap: "SW1A 1AA",
    labelProvincia: "Province / State / Region",
    phProvincia: "State or region",
    labelPaese: "Country",
    kickerNote: "Notes",
    labelNote: "Additional notes",
    phNote: "Preferred timing, questions, etc.",
    consenso: "I consent to my data being processed in line with the boatyard's privacy policy.",
    modificaConfigurazione: "← Edit configuration",
    inviaPreventivo: "Send quote request",

    richiediInfoSu: nome => `Request information about the ${nome}`,
    kickerMessaggio: "Message",
    labelMessaggio: "What would you like to know?",
    phMessaggio: "Availability, lead times, possible customisations, etc.",
    tornaCambiaBarca: "← Change boat",
    inviaInfo: "Send information request",

    errNomeEmail: "Please enter your name and email to continue.",
    errIndirizzo: "Please enter the complete delivery address (address, city, postal code, province/state).",
    errConsenso: "You must consent to data processing in order to send the request.",
    errInvio: "Sending failed. Please try again or contact the boatyard directly.",

    stampRicevuta: "Request received",
    grazie: nome => `Thank you, ${nome}!`,
    confermaInfo: (barca, email) => `Your information request for the <strong>${barca}</strong> has been received. The boatyard will contact you at ${email} with everything you asked about.`,
    confermaPreventivo: (barca, citta, paese, email) => `Your quote request for the <strong>${barca}</strong> has been received, including delivery to ${citta} (${paese}). The boatyard will contact you at ${email} with a detailed quote.`
  }
};

/* Testo dell'interfaccia. Le voci parametriche sono funzioni: gli argomenti
   extra vengono passati così come sono (vedi t("grazie", nome)). */
function t(chiave, ...args){
  const dizionario = I18N[LANG] || I18N.it;
  const voce = chiave in dizionario ? dizionario[chiave] : I18N.it[chiave];
  if(voce === undefined) return chiave;
  return typeof voce === "function" ? voce(...args) : voce;
}

/* Etichetta di un dato nella lingua corrente, con fallback all'italiano.
   Vale sia per le stringhe (label/desc/plate) sia per gli array
   (circuitiInclusi): un array non vuoto è comunque truthy.
   Il fallback è voluto — una barca nuova aggiunta senza i campi `_en`
   resta leggibile in inglese (in italiano) invece di mostrare un buco. */
function L(oggetto, campo = "label"){
  if(!oggetto) return "";
  if(LANG !== "it"){
    const tradotto = oggetto[campo + "_" + LANG];
    if(tradotto) return tradotto;
  }
  return oggetto[campo] !== undefined ? oggetto[campo] : "";
}

/* Prezzo nel formato della lingua: 3.650 in italiano, 3,650 in inglese.
   Tutti i prezzi del cantiere sono IVA esclusa: il suffisso va sempre mostrato. */
const LOCALE_NUMERI = { it: "it-IT", en: "en-GB" };
const SUFFISSO_IVA = { it: "+ IVA", en: "+ VAT" };
function fmtPrezzo(numero){
  return "€" + Number(numero).toLocaleString(LOCALE_NUMERI[LANG] || "it-IT") + " " + (SUFFISSO_IVA[LANG] || SUFFISSO_IVA.it);
}

/* Le misure nelle specs sono scritte una volta sola nel formato italiano
   ("2,36 m", "3,5 mq"): qui vengono adattate alla lingua invece di essere
   duplicate in ogni barca — virgola decimale → punto, "mq" → "sq m". */
function fmtSpec(valore){
  if(LANG === "it") return valore;
  return String(valore).replace(/(\d),(\d)/g, "$1.$2").replace(/\bmq\b/g, "sq m");
}

/* ============================================================
   PAESI — solo codici ISO 3166-1 alpha-2: i nomi visualizzati
   li produce Intl.DisplayNames nella lingua corrente, così non
   serve mantenere a mano un secondo elenco di 195 paesi per
   ogni lingua aggiunta. Il valore inviato dal <select> è il
   codice, non il nome: buildRiepilogoTesto lo riconverte nel
   nome italiano (la mail la legge il cantiere) e la schermata
   di conferma nel nome della lingua del cliente.
   ============================================================ */
const PAESI = [
  "AF","AL","DZ","AD","AO","AG","SA","AR","AM","AU","AT","AZ","BS","BH","BD","BB","BE","BZ",
  "BJ","BT","BY","BO","BA","BW","BR","BN","BG","BF","BI","KH","CM","CA","CV","CZ","TD","CL",
  "CN","CY","VA","CO","KM","CD","CG","KP","KR","CI","CR","HR","CU","DK","DM","EC","EG","SV",
  "AE","ER","EE","SZ","ET","FJ","PH","FI","FR","GA","GM","GE","DE","GH","JM","JP","DJ","JO",
  "GR","GD","GT","GN","GQ","GW","GY","HT","HN","IN","ID","IR","IQ","IE","IS","MH","SB","IL",
  "IT","KZ","KE","KG","KI","XK","KW","LA","LS","LV","LB","LR","LY","LI","LT","LU","MK","MG",
  "MW","MY","MV","ML","MT","MA","MR","MU","MX","FM","MD","MC","MN","ME","MZ","MM","NA","NR",
  "NP","NI","NE","NG","NO","NZ","OM","NL","PK","PW","PA","PG","PY","PE","PL","PT","QA","GB",
  "CF","DO","RO","RW","RU","KN","LC","VC","WS","SM","ST","SN","RS","SC","SL","SG","SY","SK",
  "SI","SO","ES","LK","US","SS","ZA","SD","SR","SE","CH","TJ","TZ","PS","TH","TL","TG","TO",
  "TT","TN","TR","TM","TV","UA","UG","HU","UY","UZ","VU","VE","VN","YE","ZM","ZW"
];

/* Nome del paese in una lingua data. Il try/catch copre i browser molto
   vecchi senza Intl.DisplayNames: in quel caso resta il codice ISO, brutto
   ma comprensibile, invece di un errore che bloccherebbe tutta la render. */
function nomePaese(codice, lingua = LANG){
  try{
    return new Intl.DisplayNames([lingua], { type: "region" }).of(codice) || codice;
  }catch(e){
    return codice;
  }
}

function renderPaesiOptions(){
  const elenco = PAESI
    .map(codice => [codice, nomePaese(codice)])
    .sort((a, b) => a[1].localeCompare(b[1], LANG));
  const opzione = ([codice, nome]) => `<option value="${codice}">${nome}</option>`;
  // Italia in cima come default, poi gli altri in ordine alfabetico della
  // lingua corrente (Italia esclusa dal secondo elenco, per non comparire due volte).
  const italia = elenco.find(([codice]) => codice === "IT");
  return (italia ? opzione(italia) : "") +
    `<option disabled>──────────</option>` +
    elenco.filter(([codice]) => codice !== "IT").map(opzione).join("");
}

/* ============================================================
   DATA — placeholder structure per la maggior parte delle barche
   (da sostituire con dati reali forniti dal cantiere), tranne
   Optimist che usa già dati reali. Ogni barca eredita le categorie
   di opzioni comuni (coloreScafo, vele, ferramenta, accessori) e
   può sovrascrivere/aggiungere campi specifici — le categorie
   valide sono elencate in SWATCH_CATEGORIES e CHECKBOX_CATEGORIES
   più sotto (scelta singola vs. multipla). Un'opzione con
   nascosto:true resta nei dati ma non viene mostrata in UI.
   ============================================================ */

const opzioniComuni = {
  coloreScafo: [
    { id: "bianco", label: "Bianco classico", label_en: "Classic white", hex: "#FFFFFF", prezzo: 0 },
    { id: "blu", label: "Blu Cantiere", label_en: "Boatyard blue", hex: "#1B3A6B", prezzo: 0 },
    { id: "rosso", label: "Rosso Regata", label_en: "Racing red", hex: "#A8432F", prezzo: 0 },
    { id: "grigio", label: "Grigio Antracite", label_en: "Anthracite grey", hex: "#4A4F55", prezzo: 0 }
  ],
  ferramenta: [
    { id: "base", label: "Ferramenta base", label_en: "Standard fittings", prezzo: 0 },
    { id: "regata", label: "Ferramenta da regata (Harken)", label_en: "Racing fittings (Harken)", prezzo: 0 }
  ],
  accessori: [
    { id: "carrello", label: "Carrello di alaggio", label_en: "Launching trolley", desc: "Per spostamento e rimessaggio a terra", desc_en: "For moving and storing the boat ashore" },
    { id: "telo", label: "Telo di copertura", label_en: "Boat cover", desc: "Protezione scafo da sole e intemperie", desc_en: "Protects the hull from sun and weather" },
    { id: "pagaia", label: "Pagaia di sicurezza", label_en: "Safety paddle", desc: "Dotazione di sicurezza richiesta in regata", desc_en: "Safety equipment required when racing" }
  ]
};

const barche = {
  optimist: {
    nome: "Optimist",
    plate: "Barca da regata", plate_en: "Racing dinghy",
    // Dati reali forniti dal cantiere (a differenza delle altre barche, ancora segnaposto).
    // Il pacchetto base include: palloni di galleggiamento, cinghie puntapiedi imbottite,
    // bozzello Harken Carbon con molle nere, spessori deriva, scotta randa con winch Harken
    // 1.5 X-Grip, piede albero regolabile ultima generazione, kit sicurezza (cima di traino,
    // pagaia, 2 sassole), certificato di stazza. Vele non incluse: si acquistano a parte da
    // una veleria, non fanno parte di questo configuratore.
    prezzoBase: 3650,
    hasPricing: true,
    specs: { lunghezza: "2,36 m", larghezza: "1,13 m", supVelica: "3,5 mq", peso: "35 kg" },
    // Scafo disponibile solo bianco: nessuna scelta di colore per l'Optimist.
    opzioni: {
      timone: [
        { id: "dsk", label: "Timone DSK (barra, agugliotti, stick Faccenda)", label_en: "DSK rudder (tiller, pintles, Faccenda extension)", prezzo: 280 },
        // Non in produzione: prezzo allineato al DSK, tenuto pronto per riattivazione futura.
        { id: "faccenda", label: "Timone Faccenda (barra e stick)", label_en: "Faccenda rudder (tiller and extension)", prezzo: 280, nascosto: true }
      ],
      deriva: [
        { id: "dsk_flexis", label: "Deriva DSK Flexis", label_en: "DSK Flexis centreboard", prezzo: 250 },
        { id: "dsk_exelixis", label: "Deriva DSK Exelixis", label_en: "DSK Exelixis centreboard", prezzo: 250 },
        { id: "faccenda_flex", label: "Deriva Faccenda Flex", label_en: "Faccenda Flex centreboard", prezzo: 250, nascosto: true },
        { id: "faccenda_strong", label: "Deriva Faccenda Strong", label_en: "Faccenda Strong centreboard", prezzo: 250, nascosto: true },
        { id: "faccenda_hyperflex", label: "Deriva Faccenda Hyperflex", label_en: "Faccenda Hyperflex centreboard", prezzo: 250, nascosto: true }
      ],
      alberi: [
        { id: "cd_soft", label: "CD Sails Soft", label_en: "CD Sails Soft", prezzo: 350 },
        { id: "cd_medium", label: "CD Sails Medium", label_en: "CD Sails Medium", prezzo: 350 },
        { id: "cd_hard", label: "CD Sails Hard", label_en: "CD Sails Hard", prezzo: 350 },
        { id: "optimax_mk3", label: "Optimax MK3", label_en: "Optimax MK3", prezzo: 350 },
        { id: "optimax_mk3_flex", label: "Optimax MK3 Flex", label_en: "Optimax MK3 Flex", prezzo: 350 },
        { id: "optimax_mk3_medium", label: "Optimax MK3 Medium", label_en: "Optimax MK3 Medium", prezzo: 350 },
        { id: "optimax_mk4", label: "Optimax MK4", label_en: "Optimax MK4", prezzo: 350 }
      ],
      boma: [
        { id: "optimax_mk4", label: "Optimax MK4", label_en: "Optimax MK4", prezzo: 150 },
        { id: "optimax_mk5", label: "Optimax MK5", label_en: "Optimax MK5", prezzo: 150 }
      ],
      picco: [
        { id: "optimax_mk3", label: "Optimax MK3", label_en: "Optimax MK3", prezzo: 88 },
        { id: "optimax_mk3_flex", label: "Optimax MK3 Flex", label_en: "Optimax MK3 Flex", prezzo: 88 },
        { id: "optimax_mk3_hyperflex", label: "Optimax MK3 Hyperflex", label_en: "Optimax MK3 Hyperflex", prezzo: 88 }
      ],
      attrezzatura: [
        { id: "scotta_gottifredi", label: "Scotta randa Gottifredi", label_en: "Gottifredi mainsheet", desc: "Ricambio/upgrade della scotta randa", desc_en: "Replacement/upgrade for the mainsheet", prezzo: 79 },
        { id: "quarto_rinvio", label: "Quarto rinvio", label_en: "Fourth turning block", desc: "Rinvio aggiuntivo per la scotta randa", desc_en: "Additional turning block for the mainsheet", prezzo: 69 },
        { id: "cinghie_leggere", label: "Cinghie leggere", label_en: "Lightweight toe straps", desc: "Versione alleggerita delle cinghie puntapiedi", desc_en: "Lightweight version of the toe straps", prezzo: 90 }
      ],
      coperture: [
        { id: "telo_sopra", label: "Telo sopra Faccenda in Polycotton", label_en: "Faccenda Polycotton top cover", desc: "Copertura superiore, protezione da sole e intemperie", desc_en: "Top cover, protection from sun and weather", prezzo: 95 },
        { id: "telo_sotto", label: "Telo sotto Faccenda imbottito", label_en: "Faccenda padded bottom cover", desc: "Telo imbottito traspirante, protezione scafo dal basso", desc_en: "Breathable padded cover, protects the hull from underneath", prezzo: 170 },
        { id: "copri_timone_deriva", label: "Copri timone e deriva Faccenda", label_en: "Faccenda rudder and centreboard cover", desc: "Protezione dedicata per timone e deriva", desc_en: "Dedicated protection for rudder and centreboard", prezzo: 85 },
        { id: "copri_albero", label: "Copri albero Faccenda", label_en: "Faccenda mast cover", desc: "Protezione dedicata per l'albero", desc_en: "Dedicated protection for the mast", prezzo: 75 },
        { id: "carrello_practic", label: "Carrello di alaggio Practic", label_en: "Practic launching trolley", desc: "Per spostamento e rimessaggio a terra", desc_en: "For moving and storing the boat ashore", prezzo: 185 },
        { id: "pacco_spedizione", label: "Pacco per spedizione", label_en: "Shipping crate", desc: "Imballo per la spedizione della barca", desc_en: "Packaging for shipping the boat", prezzo: 100 }
      ]
    }
  },
  vaurien: {
    nome: "Vaurien",
    plate: "Classe Vaurien", plate_en: "Vaurien Class",
    // Dati reali forniti dal cantiere. Niente prezzoBase fisso: il prezzo di
    // partenza dipende dal tipo di scafo (regata/scuola), scelto come swatch
    // a scelta obbligata in tipoScafo — vedi hasPricing/prezzoPartenza più
    // sotto per come viene gestita la UI del prezzo senza un prezzoBase fisso.
    hasPricing: true,
    specs: { lunghezza: "4,09 m", larghezza: "1,59 m", supVelica: "9,5 mq", peso: "108 kg" },
    opzioni: {
      tipoScafo: [
        { id: "regata", label: "Scafo da regata", label_en: "Racing hull", prezzo: 6200 },
        { id: "scuola", label: "Scafo da scuola", label_en: "Sailing-school hull", prezzo: 4600 }
      ],
      coloreScafo: [
        { id: "bianco", label: "Bianco classico", label_en: "Classic white", hex: "#FFFFFF", prezzo: 0 },
        { id: "blu", label: "Blu Cantiere", label_en: "Boatyard blue", hex: "#1B3A6B", prezzo: 250 },
        { id: "rosso", label: "Rosso Regata", label_en: "Racing red", hex: "#A8432F", prezzo: 250 },
        { id: "grigio", label: "Grigio Antracite", label_en: "Anthracite grey", hex: "#4A4F55", prezzo: 250 }
      ],
      ferramenta: [
        { id: "base", label: "Ferramenta base", label_en: "Standard fittings", prezzo: 0 },
        { id: "regata", label: "Ferramenta da regata (Harken)", label_en: "Racing fittings (Harken)", prezzo: 800 }
      ],
      alberatura: [
        { id: "albero_selden", label: "Albero Selden", label_en: "Selden mast", prezzo: 1520 },
        { id: "boma_selden", label: "Boma Selden", label_en: "Selden boom", prezzo: 360 },
        { id: "tangone_selden", label: "Tangone Selden", label_en: "Selden spinnaker pole", prezzo: 170 },
        { id: "rigging_pack", label: "Rigging Pack", label_en: "Rigging Pack", prezzo: 280 }
      ],
      veleRegata: [
        { id: "randa", label: "Randa da regata", label_en: "Racing mainsail", prezzo: 700 },
        { id: "fiocco", label: "Fiocco da regata", label_en: "Racing jib", prezzo: 390 },
        { id: "spinnaker", label: "Spinnaker da regata bianco", label_en: "White racing spinnaker", prezzo: 500 }
      ],
      componentiFaccenda: [
        { id: "timone", label: "Timone Faccenda", label_en: "Faccenda rudder", prezzo: 440 },
        { id: "deriva", label: "Deriva Faccenda", label_en: "Faccenda centreboard", prezzo: 350 }
      ],
      accessori: [
        { id: "svuotatore", label: "Svuotatore", label_en: "Self-bailer", prezzo: 150 },
        { id: "sacche_spinnaker", label: "Due sacche per spinnaker", label_en: "Two spinnaker bags", prezzo: 110 },
        { id: "cinghie_puntapiedi", label: "4 cinghie puntapiedi", label_en: "4 toe straps", prezzo: 120 }
      ],
      attrezzatura: [
        { id: "kit_spinnaker", label: "Kit attrezzatura Spinnaker", label_en: "Spinnaker rigging kit", desc: "Comprende: 2 torrette, 4 strozzatori, 5 bozzelli, scotta del circuito spinnaker, circuito drizza spinnaker", desc_en: "Includes: 2 stand-up bases, 4 cleats, 5 blocks, spinnaker sheet system, spinnaker halyard system", prezzo: 430 }
      ],
      coperture: [
        { id: "carrellino", label: "Carrellino", label_en: "Launching trolley", desc: "Per spostamento e rimessaggio a terra", desc_en: "For moving and storing the boat ashore", prezzo: 290 },
        { id: "telo_sopra", label: "Telo sopra", label_en: "Top cover", desc: "Protezione superiore da sole e intemperie", desc_en: "Top protection from sun and weather", prezzo: 280 },
        { id: "telo_sotto", label: "Telo sotto", label_en: "Bottom cover", desc: "Protezione scafo dal basso", desc_en: "Protects the hull from underneath", prezzo: 230 },
        { id: "sacca_deriva_timone", label: "Sacca deriva e timone", label_en: "Centreboard and rudder bag", desc: "Protezione dedicata per deriva e timone", desc_en: "Dedicated protection for centreboard and rudder", prezzo: 99 }
      ]
    },
    // Dotazioni di serie già incluse nello scafo, senza prezzo a parte:
    // mostrate solo come nota informativa (vedi renderStepOptions).
    circuitiInclusi: ["Circuito ghinda", "Vang", "Cunningham fiocco e randa"],
    circuitiInclusi_en: ["Luff tension system", "Vang", "Jib and mainsail cunningham"]
  },
  "420": {
    nome: "420",
    plate: "Classe 420", plate_en: "420 Class",
    // Dati reali forniti dal cantiere. Scafo già completo di attrezzatura e
    // strozza: niente colore scafo né set vele per questo modello (vele
    // acquistate a parte, come per l'Optimist).
    prezzoBase: 6500,
    hasPricing: true,
    specs: { lunghezza: "4,20 m", larghezza: "1,63 m", supVelica: "10,25 mq", peso: "80 kg" },
    opzioni: {
      // Ferramenta Harken già montata di serie sullo scafo (non un extra a
      // scelta come su Optimist/Vaurien): niente opzione "base" da togliere
      // e nessun prezzo a supplemento, vedi richiesta cantiere.
      ferramenta: [
        { id: "regata", label: "Ferramenta Harken (di serie)", label_en: "Harken fittings (standard)", prezzo: 0 }
      ],
      componentiFaccenda: [
        { id: "timone_barra", label: "Timone + barra", label_en: "Rudder + tiller", prezzo: 800 },
        { id: "deriva", label: "Deriva", label_en: "Centreboard", prezzo: 600 }
      ],
      alberatura: [
        { id: "albero_superspars", label: "Albero SuperSpars", label_en: "SuperSpars mast", prezzo: 1800 },
        { id: "hook", label: "Hook", label_en: "Hook", prezzo: 400 },
        { id: "boma_selden", label: "Boma Selden / SuperSpars", label_en: "Selden / SuperSpars boom", prezzo: 360 },
        { id: "tangone_selden", label: "Tangone Selden", label_en: "Selden spinnaker pole", prezzo: 170 }
      ],
      coperture: [
        { id: "telo_sopra", label: "Telo sopra", label_en: "Top cover", desc: "Protezione superiore da sole e intemperie", desc_en: "Top protection from sun and weather", prezzo: 270 },
        { id: "telo_sotto", label: "Telo sotto", label_en: "Bottom cover", desc: "Protezione scafo dal basso", desc_en: "Protects the hull from underneath", prezzo: 230 },
        { id: "busta_coprialbero", label: "Busta coprialbero", label_en: "Mast bag", desc: "Protezione dedicata per l'albero", desc_en: "Dedicated protection for the mast", prezzo: 110 },
        { id: "busta_copritimone", label: "Busta copritimone", label_en: "Rudder bag", desc: "Protezione dedicata per il timone", desc_en: "Dedicated protection for the rudder", prezzo: 70 },
        { id: "carrellino", label: "Carrellino di alaggio", label_en: "Launching trolley", desc: "Per spostamento e rimessaggio a terra", desc_en: "For moving and storing the boat ashore", prezzo: 300 }
      ]
    }
  },
  "470": {
    nome: "470",
    plate: "Classe 470", plate_en: "470 Class",
    richiestaInfo: true,
    specs: { lunghezza: "4,70 m", larghezza: "1,68 m", supVelica: "12,7 mq", peso: "120 kg" },
    opzioni: {
      ...opzioniComuni,
      accessori: opzioniComuni.accessori.concat([
        { id: "trapezio", label: "Kit trapezio", label_en: "Trapeze kit", desc: "Per andature al trapezio in equipaggio", desc_en: "For trapezing with a crew" }
      ])
    }
  },
  marta510: {
    nome: "Marta 5.10",
    plate: "Deriva polivalente", plate_en: "All-round dinghy",
    richiestaInfo: true,
    specs: { lunghezza: "5,10 m", larghezza: "1,80 m", supVelica: "—", peso: "—" },
    opzioni: opzioniComuni
  },
  flyingJunior: {
    nome: "Flying Junior",
    plate: "Classe FJ", plate_en: "FJ Class",
    // Nessuna configurazione intermedia: si passa direttamente alla richiesta
    // di informazioni (vedi richiestaInfo più sotto e renderStepInfoRequest).
    richiestaInfo: true,
    // Temporaneamente esclusa dalla griglia di selezione (vedi renderStepBoat).
    nascosta: true,
    specs: { lunghezza: "4,04 m", larghezza: "1,50 m", supVelica: "9,7 mq", peso: "75 kg" },
    opzioni: {
      ...opzioniComuni,
      vele: [
        { id: "standard", label: "Set vele standard", label_en: "Standard sail set", prezzo: 0 },
        { id: "regata", label: "Set vele regata", label_en: "Racing sail set", prezzo: 0 }
      ]
    }
  },
  snipe: {
    nome: "Snipe",
    plate: "Classe Snipe", plate_en: "Snipe Class",
    richiestaInfo: true,
    // Temporaneamente esclusa dalla griglia di selezione (vedi renderStepBoat).
    nascosta: true,
    specs: { lunghezza: "4,72 m", larghezza: "1,52 m", supVelica: "10,3 mq", peso: "180 kg" },
    opzioni: opzioniComuni
  }
};

/* Ordine di visualizzazione nella griglia (step 0). Serve perché le chiavi
   numeriche come "420"/"470" verrebbero altrimenti sempre iterate per prime
   in ordine numerico da Object.keys/entries, indipendentemente dall'ordine
   con cui sono scritte nell'oggetto barche sopra — una particolarità di JS
   che altrimenti vanificherebbe qualsiasi riordino manuale. */
const ORDINE_BARCHE = ["optimist", "vaurien", "420", "470", "marta510", "flyingJunior", "snipe"];

/* Foto reali delle barche: risolte QUI, non nei singoli oggetti barca sopra.
   Motivo: questo file (configuratore-barche.js) è caricato su Shopify come
   asset statico del tema, e gli asset statici NON passano dal motore Liquid
   — solo il contenuto del blocco Custom Liquid nell'.html viene processato.
   Un tag Liquid scritto qui (es. immagine:"{{ 'x.webp'|file_url }}" dentro
   un oggetto barca) resterebbe quindi testo letterale non risolto anche su
   Shopify, e boatVisual() ricadrebbe sempre sulla silhouette SVG (bug reale
   riscontrato dopo aver estratto il JS in questo file). La soluzione: il
   blocco Custom Liquid (che i tag Liquid li risolve davvero) popola
   window.CDF_IMAGES con gli URL reali prima di caricare questo script —
   vedi lo <script> inline in configuratore-barche.html, subito prima del
   <script src="configuratore-barche.js">. Qui li riattacchiamo ai rispettivi
   oggetti barca. In locale window.CDF_IMAGES esiste comunque (i tag Liquid
   restano testo non risolto, stessa sintassi JS valida) e boatVisual() ci si
   accorge comunque che non sono URL veri, ricadendo sul placeholder SVG. */
if(typeof window !== "undefined" && window.CDF_IMAGES){
  Object.keys(window.CDF_IMAGES).forEach(id => {
    if(barche[id]) barche[id].immagine = window.CDF_IMAGES[id];
  });
}

/* ============================================================
   STATE
   ============================================================ */

/* Categorie a scelta singola (swatch) e multipla (checkbox) note al configuratore.
   Ogni barca mostra solo le categorie presenti nel proprio oggetto opzioni.
   Dichiarate prima di scelteVuote()/state perché quest'ultima le legge per
   inizializzare dinamicamente ogni chiave nota (invece di elencarle a mano,
   il che andrebbe facilmente disallineato aggiungendo nuove categorie). */
const SWATCH_CATEGORIES = {
  tipoScafo: { kicker: "Scafo", kicker_en: "Hull", title: "Tipo di scafo", title_en: "Hull type" },
  vele: { kicker: "Velatura", kicker_en: "Sails", title: "Set vele", title_en: "Sail set" },
  ferramenta: { kicker: "Attrezzatura", kicker_en: "Fittings", title: "Ferramenta", title_en: "Deck fittings" },
  timone: { kicker: "Timoneria", kicker_en: "Steering", title: "Timone", title_en: "Rudder" },
  deriva: { kicker: "Timoneria", kicker_en: "Steering", title: "Deriva", title_en: "Centreboard" },
  alberi: { kicker: "Alberatura", kicker_en: "Spars", title: "Albero", title_en: "Mast" },
  boma: { kicker: "Alberatura", kicker_en: "Spars", title: "Boma", title_en: "Boom" },
  picco: { kicker: "Alberatura", kicker_en: "Spars", title: "Picco", title_en: "Sprit" }
};
const CHECKBOX_CATEGORIES = {
  componentiFaccenda: { kicker: "Componenti Faccenda", kicker_en: "Faccenda components", title: "Timone e deriva Faccenda", title_en: "Faccenda rudder and centreboard" },
  alberatura: { kicker: "Attrezzatura albero", kicker_en: "Spars and rigging", title: "Albero, boma e tangone", title_en: "Mast, boom and spinnaker pole" },
  veleRegata: { kicker: "Velatura", kicker_en: "Sails", title: "Vele da regata", title_en: "Racing sails" },
  accessori: { kicker: "Dotazioni", kicker_en: "Equipment", title: "Accessori opzionali", title_en: "Optional accessories" },
  attrezzatura: { kicker: "Dotazioni extra", kicker_en: "Extra equipment", title: "Attrezzatura opzionale", title_en: "Optional equipment" },
  coperture: { kicker: "Coperture", kicker_en: "Covers", title: "Coperture e accessori", title_en: "Covers and accessories" }
};

function scelteVuote(){
  const scelte = { coloreScafo: null };
  Object.keys(SWATCH_CATEGORIES).forEach(k => { scelte[k] = null; });
  Object.keys(CHECKBOX_CATEGORIES).forEach(k => { scelte[k] = []; });
  return scelte;
}

let state = {
  step: 0,
  barcaId: null,
  scelte: scelteVuote(),
  contatto: { nome: "", email: "", telefono: "", note: "" }
};

/* ============================================================
   SILHOUETTE — placeholder grafico generico (verrà sostituito
   da immagini reali per barca quando disponibili)
   ============================================================ */
function silhouetteSVG(){
  return `<svg class="boat-silhouette" viewBox="0 0 200 70" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 50 Q100 70 180 50 L165 56 Q100 64 35 56 Z" fill="#16263B" opacity="0.85"/>
    <path d="M95 50 L95 12 L130 50 Z" fill="#B8893F" opacity="0.9"/>
    <line x1="95" y1="50" x2="95" y2="10" stroke="#16263B" stroke-width="1.5"/>
  </svg>`;
}

/* Immagine reale della barca se disponibile e risolta (b.immagine), altrimenti
   silhouette placeholder. Su Shopify il tag Liquid in b.immagine viene risolto
   nell'URL CDN reale (che inizia sempre con http:// https:// oppure //);
   in locale resta il tag Liquid non sostituito e quindi si ricade sul
   placeholder. Il controllo verifica che il valore sembri un URL vero, invece
   di cercare i delimitatori Liquid come testo — scriverli qui letteralmente
   confonderebbe il parser Liquid di Shopify, che analizza l'intero file come
   testo grezzo (commenti e stringhe JS inclusi).
   Questo controllo da solo NON basta però: il filtro file_url di Shopify
   genera comunque un URL dall'aspetto valido anche se il file non è stato
   ancora caricato in Contenuto → File (non verifica che esista davvero),
   quindi per quei casi il tag <img> viene comunque emesso ma la richiesta
   HTTP fallisce con un'icona di immagine rotta invece di ricadere sull'SVG.
   Da qui l'onerror inline: se il browser non riesce a caricare l'immagine
   per qualunque motivo (file non ancora caricato, cancellato, rinominato...),
   sostituisce l'<img> con la stessa silhouette SVG usata per il fallback
   "non risolto", così il risultato visivo è identico in entrambi i casi. */
function boatVisual(b){
  const img = b.immagine;
  const risolta = typeof img === "string" && /^(https?:)?\/\//.test(img.trim());
  if(!risolta) return silhouetteSVG();
  const fallback = JSON.stringify(silhouetteSVG());
  return `<img class="boat-silhouette" src="${img}" alt="${b.nome}" loading="lazy" onerror='this.outerHTML=${fallback}'>`;
}

/* ============================================================
   RENDER
   ============================================================ */
const app = document.getElementById("app");
const railEl = document.getElementById("rail");
const railLabelsEl = document.getElementById("railLabels");
const stepNumEl = document.getElementById("stepNum");
const stepTotalEl = document.getElementById("stepTotal");
// Titolo e parola "Fase" vivono nel markup statico (blocco Custom Liquid), ma
// il testo lo decide il dizionario I18N: così tutte le traduzioni restano in
// un posto solo invece di essere metà qui e metà in Liquid.
const titoloEl = document.getElementById("cdfTitolo");
const faseEl = document.getElementById("cdfFase");

/* Le barche con richiestaInfo:true non hanno lo step di personalizzazione:
   la rail per queste mostra solo 2 fasi invece di 3. state.step resta 0/1/2
   come per le altre barche (si salta semplicemente l'1), ma qui lo step 2
   viene rimappato sulla seconda fase visibile. */
function faseCorrenteBarca(){
  return state.barcaId ? barche[state.barcaId] : null;
}
function getFasi(){
  const b = faseCorrenteBarca();
  if(b && b.richiestaInfo) return t("fasiInfo");
  return t("fasiComplete");
}
function getFaseIndex(){
  const b = faseCorrenteBarca();
  if(b && b.richiestaInfo) return state.step === 0 ? 0 : 1;
  return state.step;
}

function renderRail(){
  if(titoloEl) titoloEl.textContent = t("titolo");
  if(faseEl) faseEl.textContent = t("fase").toUpperCase();
  const fasi = getFasi();
  const faseIndex = getFaseIndex();
  railEl.innerHTML = "";
  fasi.forEach((_, i)=>{
    const seg = document.createElement("div");
    seg.className = "seg" + (i < faseIndex ? " done" : i === faseIndex ? " active" : "");
    railEl.appendChild(seg);
  });
  railLabelsEl.innerHTML = fasi.map(f => `<span>${f}</span>`).join("");
  stepNumEl.textContent = String(faseIndex+1).padStart(2,"0");
  stepTotalEl.textContent = String(fasi.length).padStart(2,"0");
}

function render(){
  renderRail();
  if(state.step === 0) renderStepBoat();
  else if(state.step === 1) renderStepOptions();
  else{
    const b = barche[state.barcaId];
    if(b && b.richiestaInfo) renderStepInfoRequest();
    else renderStepSummary();
  }
}

/* Prezzo "a partire da" mostrato sulla card barca (step 0): il prezzoBase
   fisso se c'è, altrimenti il minimo tra le opzioni tipoScafo (es. Vaurien,
   dove il prezzo dipende dal tipo di scafo scelto). null per le barche
   ancora senza dati di prezzo reali. */
function prezzoPartenza(b){
  if(b.prezzoBase) return b.prezzoBase;
  if(b.opzioni.tipoScafo?.length) return Math.min(...b.opzioni.tipoScafo.map(o => o.prezzo));
  return null;
}

/* Prezzo base + somma di tutte le opzioni a pagamento attualmente selezionate.
   Boat senza hasPricing (dati ancora segnaposto) non mostrano alcun totale. */
function calcolaTotale(b){
  const prezzoOpzione = (key, id) => (b.opzioni[key] || []).find(o => o.id === id)?.prezzo || 0;
  let totale = b.prezzoBase || 0;
  totale += prezzoOpzione("coloreScafo", state.scelte.coloreScafo);
  Object.keys(SWATCH_CATEGORIES).forEach(key => {
    totale += prezzoOpzione(key, state.scelte[key]);
  });
  Object.keys(CHECKBOX_CATEGORIES).forEach(key => {
    (state.scelte[key] || []).forEach(id => { totale += prezzoOpzione(key, id); });
  });
  return totale;
}

/* Riepilogo configurazione + indirizzo spedizione come testo semplice, usato
   come corpo del messaggio del form di contatto nativo Shopify.

   Deliberatamente SEMPRE in italiano, anche per un cliente che sta usando il
   configuratore in inglese: questa mail la legge il cantiere, non il cliente.
   Per questo qui si usano `o.label` e `cfg.title` diretti invece degli helper
   L()/t() — se un domani servisse la versione inglese basta passarli a L().
   La lingua del cliente viene segnalata in testa, per sapere in che lingua
   rispondere. */
function buildRiepilogoTesto(b){
  const trovaLabel = (key, id) => (b.opzioni[key] || []).find(o => o.id === id)?.label || "—";
  const righe = [];
  righe.push(`Richiesta di preventivo — ${b.nome} (${b.plate})`);
  if(LANG !== "it") righe.push(`Lingua del cliente: ${LANG.toUpperCase()} — rispondere in inglese`);
  if(b.prezzoBase) righe.push(`Prezzo base: €${b.prezzoBase.toLocaleString("it-IT")} + IVA`);
  if(b.opzioni.coloreScafo) righe.push(`Colore scafo: ${trovaLabel("coloreScafo", state.scelte.coloreScafo)}`);
  Object.entries(SWATCH_CATEGORIES).forEach(([key, cfg]) => {
    if(b.opzioni[key]) righe.push(`${cfg.title}: ${trovaLabel(key, state.scelte[key])}`);
  });
  Object.entries(CHECKBOX_CATEGORIES).forEach(([key, cfg]) => {
    if(b.opzioni[key]){
      const labels = (state.scelte[key] || []).map(id => (b.opzioni[key] || []).find(o => o.id === id)?.label).filter(Boolean);
      righe.push(`${cfg.title}: ${labels.length ? labels.join(", ") : "Nessuno"}`);
    }
  });
  if(b.circuitiInclusi) righe.push(`Incluso di serie: ${b.circuitiInclusi.join(", ")}`);
  if(b.hasPricing) righe.push(`Totale configurazione: €${calcolaTotale(b).toLocaleString("it-IT")} + IVA`);

  righe.push("");
  righe.push("Indirizzo di spedizione:");
  righe.push(state.contatto.indirizzo);
  if(state.contatto.indirizzo2) righe.push(state.contatto.indirizzo2);
  righe.push(`${state.contatto.cap} ${state.contatto.citta} (${state.contatto.provincia})`);
  // state.contatto.paese è un codice ISO (vedi renderPaesiOptions): nella mail
  // al cantiere va il nome italiano, non quello della lingua del cliente.
  righe.push(nomePaese(state.contatto.paese, "it"));

  if(state.contatto.note){ righe.push(""); righe.push(`Note: ${state.contatto.note}`); }
  return righe.join("\n");
}

/* Corpo del messaggio per il form semplificato di richiesta informazioni
   (barche con richiestaInfo:true, nessuna configurazione da riepilogare). */
function buildRiepilogoInfoTesto(b){
  const righe = [];
  righe.push(`Richiesta di informazioni — ${b.nome} (${b.plate})`);
  if(LANG !== "it") righe.push(`Lingua del cliente: ${LANG.toUpperCase()} — rispondere in inglese`);
  if(state.contatto.messaggio){ righe.push(""); righe.push(`Messaggio: ${state.contatto.messaggio}`); }
  return righe.join("\n");
}

/* ---- Step 0: scelta barca ---- */
function renderStepBoat(){
  const grid = document.createElement("div");
  grid.className = "boat-grid";

  ORDINE_BARCHE.map(id => [id, barche[id]]).filter(([id, b])=>!b.nascosta).forEach(([id, b])=>{
    const card = document.createElement("div");
    card.className = "boat-card" + (state.barcaId === id ? " selected" : "");
    card.innerHTML = `
      <div class="check-mark">✓</div>
      <div class="plate">${L(b, "plate")}</div>
      <h3>${b.nome}</h3>
      ${prezzoPartenza(b) ? `<div class="boat-price">${t("aPartireDa", fmtPrezzo(prezzoPartenza(b)))}</div>` : ""}
      ${boatVisual(b)}
      <div class="specs">
        <div>${t("specLunghezza")} <span>${fmtSpec(b.specs.lunghezza)}</span></div>
        <div>${t("specLarghezza")} <span>${fmtSpec(b.specs.larghezza)}</span></div>
        <div>${t("specSupVelica")} <span>${fmtSpec(b.specs.supVelica)}</span></div>
        <div>${t("specPeso")} <span>${fmtSpec(b.specs.peso)}</span></div>
      </div>
    `;
    // Un solo click sulla card seleziona la barca e passa subito al passo
    // successivo: step 2 (richiesta informazioni) per le barche con
    // richiestaInfo:true, altrimenti step 1 (personalizzazione). Stesso
    // comportamento per tutte le barche, nessun tasto "Continua" intermedio.
    card.addEventListener("click", ()=>{
      state.barcaId = id;
      state.scelte = scelteVuote();
      state.step = b.richiestaInfo ? 2 : 1;
      render();
    });
    grid.appendChild(card);
  });

  app.innerHTML = "";
  app.appendChild(grid);
}

/* ---- Step 1: opzioni ---- */
function renderStepOptions(){
  const b = barche[state.barcaId];
  app.innerHTML = "";

  const recap = document.createElement("div");
  recap.className = "boat-recap";
  recap.innerHTML = `
    ${boatVisual(b)}
    <div>
      <p>${L(b, "plate")}</p>
      <h4>${b.nome}</h4>
    </div>
    <button class="change-btn">${t("cambiaBarca")}</button>
  `;
  recap.querySelector(".change-btn").addEventListener("click", ()=>{ state.step = 0; render(); });
  app.appendChild(recap);

  if(b.hasPricing){
    const priceBar = document.createElement("div");
    priceBar.className = "price-bar";
    priceBar.innerHTML = `<span>${t("totaleConfigurazione")}</span><strong>${fmtPrezzo(calcolaTotale(b))}</strong>`;
    app.appendChild(priceBar);
  }

  // Colore scafo (non tutte le barche lo offrono, es. 420)
  if(b.opzioni.coloreScafo) app.appendChild(renderSwatchGroup(t("kickerFinitura"), t("titoloColoreScafo"), b.opzioni.coloreScafo, "coloreScafo", true));
  // Categorie a scelta singola (tipoScafo, vele, ferramenta, timone, deriva, alberi, boma, picco...)
  Object.entries(SWATCH_CATEGORIES).forEach(([key, cfg])=>{
    if(b.opzioni[key]) app.appendChild(renderSwatchGroup(L(cfg, "kicker"), L(cfg, "title"), b.opzioni[key], key, false));
  });
  // Categorie a scelta multipla (accessori, attrezzatura, coperture...)
  Object.entries(CHECKBOX_CATEGORIES).forEach(([key, cfg])=>{
    if(b.opzioni[key]) app.appendChild(renderAccessoryGroup(L(cfg, "kicker"), L(cfg, "title"), b.opzioni[key], key));
  });

  // Dotazioni di serie senza prezzo/scelta (es. circuiti e manovre del Vaurien): solo nota informativa.
  if(b.circuitiInclusi){
    const info = document.createElement("div");
    info.className = "option-group";
    info.innerHTML = `<span class="group-label">${t("inclusoDiSerie")}</span><h3>${t("circuitiEManovre")}</h3><p style="margin:0;color:var(--navy-soft);font-size:14px;">${L(b, "circuitiInclusi").join(", ")}.</p>`;
    app.appendChild(info);
  }

  const nav = document.createElement("div");
  nav.className = "nav-buttons";
  const back = document.createElement("button");
  back.className = "btn";
  back.textContent = t("indietro");
  back.addEventListener("click", ()=>{ state.step = 0; render(); });
  const next = document.createElement("button");
  next.className = "btn primary";
  next.textContent = t("vaiAlRiepilogo");
  // Obbligatorio solo se la barca offre quella scelta (alcune, come il 420, non hanno colore scafo).
  next.disabled = (b.opzioni.coloreScafo && !state.scelte.coloreScafo) || (b.opzioni.tipoScafo && !state.scelte.tipoScafo);
  next.addEventListener("click", ()=>{ state.step = 2; render(); });
  nav.appendChild(back);
  nav.appendChild(next);
  app.appendChild(nav);
}

function renderSwatchGroup(label, title, options, key, isColor){
  const group = document.createElement("div");
  group.className = "option-group";
  group.innerHTML = `<span class="group-label">${label}</span><h3>${title}</h3>`;
  const row = document.createElement("div");
  row.className = "swatch-row";
  options.filter(opt=>!opt.nascosto).forEach(opt=>{
    const sw = document.createElement("div");
    sw.className = "swatch" + (state.scelte[key] === opt.id ? " selected" : "");
    sw.innerHTML = (isColor ? `<span class="dot" style="background:${opt.hex}"></span>` : "") +
      `<span>${L(opt)}</span>` +
      (opt.prezzo ? `<span class="price-tag">+${fmtPrezzo(opt.prezzo)}</span>` : "");
    sw.addEventListener("click", ()=>{
      state.scelte[key] = opt.id;
      render();
    });
    row.appendChild(sw);
  });
  group.appendChild(row);
  return group;
}

function renderAccessoryGroup(label, title, options, key){
  const group = document.createElement("div");
  group.className = "option-group";
  group.innerHTML = `<span class="group-label">${label}</span><h3>${title}</h3>`;
  options.filter(opt=>!opt.nascosto).forEach(opt=>{
    const row = document.createElement("div");
    const checked = state.scelte[key].includes(opt.id);
    row.className = "accessory-row" + (checked ? " selected" : "");
    row.innerHTML = `
      <div class="left">
        <div class="checkbox">${checked ? "✓" : ""}</div>
        <div>
          <div class="name">${L(opt)}${opt.prezzo ? `<span class="price-tag">+${fmtPrezzo(opt.prezzo)}</span>` : ""}</div>
          <div class="desc">${L(opt, "desc")}</div>
        </div>
      </div>
    `;
    row.addEventListener("click", ()=>{
      const i = state.scelte[key].indexOf(opt.id);
      if(i === -1) state.scelte[key].push(opt.id);
      else state.scelte[key].splice(i,1);
      render();
    });
    group.appendChild(row);
  });
  return group;
}

/* ---- Step 2: riepilogo + richiesta preventivo ---- */
function renderStepSummary(){
  const b = barche[state.barcaId];
  app.innerHTML = "";

  const findLabel = (key, id) => L((b.opzioni[key] || []).find(o=>o.id===id)) || "—";
  const listLabels = (key) => (state.scelte[key] || []).map(id => L((b.opzioni[key] || []).find(o=>o.id===id))).filter(Boolean);

  let rows = b.opzioni.coloreScafo ? `<div class="summary-row"><span class="k">${t("titoloColoreScafo")}</span><span class="v">${findLabel("coloreScafo", state.scelte.coloreScafo)}</span></div>` : "";
  Object.entries(SWATCH_CATEGORIES).forEach(([key, cfg])=>{
    if(b.opzioni[key]) rows += `<div class="summary-row"><span class="k">${L(cfg, "title")}</span><span class="v">${findLabel(key, state.scelte[key])}</span></div>`;
  });
  Object.entries(CHECKBOX_CATEGORIES).forEach(([key, cfg])=>{
    if(b.opzioni[key]){
      const labels = listLabels(key);
      rows += `<div class="summary-row"><span class="k">${L(cfg, "title")}</span><span class="v">${labels.length ? labels.join(", ") : t("nessuno")}</span></div>`;
    }
  });
  if(b.circuitiInclusi) rows += `<div class="summary-row"><span class="k">${t("inclusoDiSerie")}</span><span class="v">${L(b, "circuitiInclusi").join(", ")}</span></div>`;

  const sheet = document.createElement("div");
  sheet.className = "summary-sheet";
  sheet.innerHTML = `
    <div class="sheet-title"><h3>${b.nome}</h3><span>${L(b, "plate")}</span></div>
    ${b.prezzoBase ? `<div class="summary-row"><span class="k">${t("prezzoBase")}</span><span class="v">${fmtPrezzo(b.prezzoBase)}</span></div>` : ""}
    ${rows}
    ${b.hasPricing ? `<div class="summary-row total"><span class="k">${t("totaleConfigurazione")}</span><span class="v">${fmtPrezzo(calcolaTotale(b))}</span></div>` : ""}
  `;
  app.appendChild(sheet);

  const form = document.createElement("div");
  form.className = "quote-form";
  form.innerHTML = `
    <h3>${t("datiPreventivo")}</h3>

    <span class="group-label">${t("kickerContatto")}</span>
    <div class="field-row">
      <div class="field"><label>${t("labelNome")}</label><input type="text" id="f_nome" placeholder="${t("phNome")}"></div>
      <div class="field"><label>${t("labelEmail")}</label><input type="email" id="f_email" placeholder="${t("phEmail")}"></div>
    </div>
    <div class="field-row">
      <div class="field full"><label>${t("labelTelefono")}</label><input type="tel" id="f_telefono" placeholder="${t("phTelefono")}"></div>
    </div>

    <span class="group-label">${t("kickerIndirizzo")}</span>
    <div class="field-row">
      <div class="field full"><label>${t("labelIndirizzo")}</label><input type="text" id="f_indirizzo" placeholder="${t("phIndirizzo")}"></div>
    </div>
    <div class="field-row">
      <div class="field full"><label>${t("labelIndirizzo2")}</label><input type="text" id="f_indirizzo2" placeholder="${t("phIndirizzo2")}"></div>
    </div>
    <div class="field-row">
      <div class="field"><label>${t("labelCitta")}</label><input type="text" id="f_citta" placeholder="${t("phCitta")}"></div>
      <div class="field"><label>${t("labelCap")}</label><input type="text" id="f_cap" placeholder="${t("phCap")}"></div>
    </div>
    <div class="field-row">
      <div class="field"><label>${t("labelProvincia")}</label><input type="text" id="f_provincia" placeholder="${t("phProvincia")}"></div>
      <div class="field">
        <label>${t("labelPaese")}</label>
        <select id="f_paese">${renderPaesiOptions()}</select>
      </div>
    </div>

    <span class="group-label">${t("kickerNote")}</span>
    <div class="field-row">
      <div class="field full"><label>${t("labelNote")}</label><textarea id="f_note" placeholder="${t("phNote")}"></textarea></div>
    </div>

    <div class="consent">
      <input type="checkbox" id="f_consent">
      <label for="f_consent">${t("consenso")}</label>
    </div>
  `;
  app.appendChild(form);

  const nav = document.createElement("div");
  nav.className = "nav-buttons";
  const back = document.createElement("button");
  back.className = "btn";
  back.textContent = t("modificaConfigurazione");
  back.addEventListener("click", ()=>{ state.step = 1; render(); });
  const send = document.createElement("button");
  send.className = "btn primary";
  send.textContent = t("inviaPreventivo");
  send.addEventListener("click", ()=>{
    const nome = document.getElementById("f_nome").value.trim();
    const email = document.getElementById("f_email").value.trim();
    const indirizzo = document.getElementById("f_indirizzo").value.trim();
    const citta = document.getElementById("f_citta").value.trim();
    const cap = document.getElementById("f_cap").value.trim();
    const provincia = document.getElementById("f_provincia").value.trim();
    const paese = document.getElementById("f_paese").value;
    const consent = document.getElementById("f_consent").checked;
    if(!nome || !email){ alert(t("errNomeEmail")); return; }
    if(!indirizzo || !citta || !cap || !provincia){ alert(t("errIndirizzo")); return; }
    if(!consent){ alert(t("errConsenso")); return; }

    state.contatto = {
      nome, email,
      telefono: document.getElementById("f_telefono").value.trim(),
      indirizzo,
      indirizzo2: document.getElementById("f_indirizzo2").value.trim(),
      citta, cap, provincia, paese,
      note: document.getElementById("f_note").value.trim()
    };

    // ----------------------------------------------------------------
    // PUNTO DI INTEGRAZIONE: invio reale tramite il form di contatto nativo
    // Shopify (vedi #cdf-hidden-form-wrap nel body). Su Shopify quel tag
    // Liquid diventa un vero form e qui sotto lo popoliamo. L'invio passa da
    // window.Shopify.captcha.protect() — non fetch() e non form.submit()
    // diretto — perché Shopify protegge di default (dal 2022) ogni form
    // 'contact' con hCaptcha: un fetch() in background la bypassa del tutto
    // e Shopify rifiuta la richiesta con 400 (bug reale riscontrato). protect()
    // esegue la verifica (di norma invisibile) e poi invia davvero il form,
    // causando un vero ricaricamento della pagina verso /contact — per
    // questo salviamo lo stato minimo in sessionStorage prima di inviare:
    // riprendiDopoInvioNativo() lo rilegge al prossimo caricamento dello
    // script per ricostruire la schermata di conferma (vedi in fondo al
    // file). In locale (Liquid non eseguito) il form non esiste: la
    // richiesta viene solo simulata, per poter comunque testare il flusso.
    // ----------------------------------------------------------------
    const formNativo = document.getElementById("cdf-contact-form");

    if(!formNativo){
      // Su Shopify window.Shopify esiste sempre: se il form nativo manca
      // comunque, il blocco Custom Liquid non è aggiornato/valido e la
      // richiesta non può essere inviata davvero. Meglio avvisare che
      // fingere un successo che nasconde il problema (vedi PUNTO DI
      // INTEGRAZIONE qui sopra). In locale (Liquid non eseguito, niente
      // window.Shopify) il flusso resta invece solo simulato.
      if(typeof window.Shopify !== "undefined"){
        alert(t("errInvio"));
        return;
      }
      renderConfirmation();
      return;
    }

    formNativo.querySelector('[name="contact[name]"]').value = nome;
    formNativo.querySelector('[name="contact[email]"]').value = email;
    formNativo.querySelector('[name="contact[phone]"]').value = state.contatto.telefono;
    formNativo.querySelector('[name="contact[body]"]').value = buildRiepilogoTesto(b);

    send.disabled = true;
    try{
      sessionStorage.setItem("cdfPendingSubmit", JSON.stringify({
        barcaId: state.barcaId, nome, email,
        citta: state.contatto.citta, paese: state.contatto.paese
      }));
    }catch(e){}

    if(window.Shopify?.captcha?.protect){
      window.Shopify.captcha.protect(formNativo, () => formNativo.submit());
    } else {
      // hCaptcha disattivato sul negozio o script non ancora pronto: invio
      // diretto, Shopify accetta comunque se la protezione non è attiva.
      formNativo.submit();
    }
  });
  nav.appendChild(back);
  nav.appendChild(send);
  app.appendChild(nav);
}

/* ---- Step 2 (variante): richiesta informazioni senza configurazione,
   per le barche con richiestaInfo:true (Flying Junior, 470, Marta 5.10,
   Snipe). Solo dati di contatto + messaggio libero, nessun indirizzo di
   spedizione né riepilogo configurazione. ---- */
function renderStepInfoRequest(){
  const b = barche[state.barcaId];
  app.innerHTML = "";

  const recap = document.createElement("div");
  recap.className = "boat-recap";
  recap.innerHTML = `
    ${boatVisual(b)}
    <div>
      <p>${L(b, "plate")}</p>
      <h4>${b.nome}</h4>
    </div>
    <button class="change-btn">${t("cambiaBarca")}</button>
  `;
  recap.querySelector(".change-btn").addEventListener("click", ()=>{ state.step = 0; render(); });
  app.appendChild(recap);

  const form = document.createElement("div");
  form.className = "quote-form";
  form.innerHTML = `
    <h3>${t("richiediInfoSu", b.nome)}</h3>

    <span class="group-label">${t("kickerContatto")}</span>
    <div class="field-row">
      <div class="field"><label>${t("labelNome")}</label><input type="text" id="f_nome" placeholder="${t("phNome")}"></div>
      <div class="field"><label>${t("labelEmail")}</label><input type="email" id="f_email" placeholder="${t("phEmail")}"></div>
    </div>
    <div class="field-row">
      <div class="field full"><label>${t("labelTelefono")}</label><input type="tel" id="f_telefono" placeholder="${t("phTelefono")}"></div>
    </div>

    <span class="group-label">${t("kickerMessaggio")}</span>
    <div class="field-row">
      <div class="field full"><label>${t("labelMessaggio")}</label><textarea id="f_messaggio" placeholder="${t("phMessaggio")}"></textarea></div>
    </div>

    <div class="consent">
      <input type="checkbox" id="f_consent">
      <label for="f_consent">${t("consenso")}</label>
    </div>
  `;
  app.appendChild(form);

  const nav = document.createElement("div");
  nav.className = "nav-buttons";
  const back = document.createElement("button");
  back.className = "btn";
  back.textContent = t("tornaCambiaBarca");
  back.addEventListener("click", ()=>{ state.step = 0; render(); });
  const send = document.createElement("button");
  send.className = "btn primary";
  send.textContent = t("inviaInfo");
  send.addEventListener("click", ()=>{
    const nome = document.getElementById("f_nome").value.trim();
    const email = document.getElementById("f_email").value.trim();
    const consent = document.getElementById("f_consent").checked;
    if(!nome || !email){ alert(t("errNomeEmail")); return; }
    if(!consent){ alert(t("errConsenso")); return; }

    state.contatto = {
      nome, email,
      telefono: document.getElementById("f_telefono").value.trim(),
      messaggio: document.getElementById("f_messaggio").value.trim()
    };

    // Stesso punto di integrazione del form preventivo (vedi renderStepSummary
    // per il perché di window.Shopify.captcha.protect() invece di fetch()):
    // su Shopify invia tramite il form di contatto nativo, in locale simula.
    const formNativo = document.getElementById("cdf-contact-form");

    if(!formNativo){
      // Vedi commento equivalente in renderStepSummary: su Shopify (window.Shopify
      // esiste) un form nativo mancante è un bug reale, non va nascosto da una
      // finta conferma.
      if(typeof window.Shopify !== "undefined"){
        alert(t("errInvio"));
        return;
      }
      renderConfirmation();
      return;
    }

    formNativo.querySelector('[name="contact[name]"]').value = nome;
    formNativo.querySelector('[name="contact[email]"]').value = email;
    formNativo.querySelector('[name="contact[phone]"]').value = state.contatto.telefono;
    formNativo.querySelector('[name="contact[body]"]').value = buildRiepilogoInfoTesto(b);

    send.disabled = true;
    try{
      sessionStorage.setItem("cdfPendingSubmit", JSON.stringify({ barcaId: state.barcaId, nome, email }));
    }catch(e){}

    if(window.Shopify?.captcha?.protect){
      window.Shopify.captcha.protect(formNativo, () => formNativo.submit());
    } else {
      formNativo.submit();
    }
  });
  nav.appendChild(back);
  nav.appendChild(send);
  app.appendChild(nav);
}

function renderConfirmation(){
  const b = barche[state.barcaId];
  // Qui il paese va mostrato nella lingua del cliente (nella mail al cantiere
  // resta invece in italiano — vedi buildRiepilogoTesto).
  const messaggio = b.richiestaInfo
    ? t("confermaInfo", b.nome, state.contatto.email)
    : t("confermaPreventivo", b.nome, state.contatto.citta, nomePaese(state.contatto.paese), state.contatto.email);
  app.innerHTML = `
    <div class="confirmation">
      <div class="stamp">${t("stampRicevuta")}</div>
      <h2>${t("grazie", state.contatto.nome.split(" ")[0])}</h2>
      <p>${messaggio}</p>
    </div>
  `;
}

/* ============================================================
   RIPRESA DOPO INVIO NATIVO — l'invio reale (vedi PUNTO DI
   INTEGRAZIONE in renderStepSummary/renderStepInfoRequest) causa
   un vero ricaricamento della pagina, perché window.Shopify.captcha.protect()
   richiede un invio nativo vero e proprio (non un fetch in background) per
   poter verificare hCaptcha. Qui, all'avvio dello script dopo quel
   ricaricamento, si ricostruisce la schermata di conferma invece di
   ripartire dallo step 0, usando lo stato minimo salvato in sessionStorage
   prima dell'invio.

   Niente controllo lato Liquid (es. form.posted_successfully?) sull'esito
   reale: il blocco Custom Liquid del Theme Editor ha rifiutato quella
   proprietà come sintassi non valida (vedi commento su #cdf-hidden-form-wrap
   in configuratore-barche.html), quindi qui si assume che l'invio sia
   andato a buon fine se sessionStorage contiene una richiesta pendente —
   valido perché arriviamo qui solo dopo che window.Shopify.captcha.protect()
   ha già superato la verifica hCaptcha e chiamato davvero formNativo.submit().
   In locale o a sessione normale (nessun invio pendente) si passa dritti al
   render() consueto.
   ============================================================ */
function riprendiDopoInvioNativo(){
  let pending = null;
  try{ pending = JSON.parse(sessionStorage.getItem("cdfPendingSubmit") || "null"); }catch(e){}
  if(!pending) return false;
  try{ sessionStorage.removeItem("cdfPendingSubmit"); }catch(e){}
  if(!barche[pending.barcaId]) return false;

  state.barcaId = pending.barcaId;
  state.contatto = { nome: pending.nome, email: pending.email, citta: pending.citta, paese: pending.paese };
  renderConfirmation();
  return true;
}

if(!riprendiDopoInvioNativo()) render();
